<template>
  <div id="app">
    <div v-if="isExpired" class="expired" >
        <div>{{ $t('expired_1') }}</div>
    </div>
    <div v-else class="submit-container" :style="{ paddingTop: '30px' }">
      <img class="icon" :src="logoUrl" alt="">
      <div class="top-bar">
          <div class="left">
              <div class="title">{{ $t('limit_time') + nickName }}</div>
              <div class="tip">{{ $t('participate') }}</div>
          </div>
          <div
            class="avatar-box"
            :style="{ width: '54px', height: '54px' }"
          >
            <img :src="avatar"/>
          </div>
      </div>
      <div class="reward-list">
          <div class="reward-title">
              <span :style="{color: '#000000'}">{{ $t('exclusive') }}</span>
              {{ ' ' }}
              <span :style="{color: '#EA3D00'}">{{ $t('reward') }}</span>
          </div>
          <div class="rewards">
              <div class="reward">
                  <div class="title">{{ isArabic ? 1 + $t('reward') : $t('reward') + 1 }}</div>
                  <div class="amount">{{ 100 }}</div>
                  <div class="name">{{ $t('token') }}</div>
                  <img class="gift" src="./assets/images/icon_gift.png">
              </div>
              <div class="plus">
                  <img src="./assets/images/icon_plus.png">
              </div>
              <div class="reward">
                  <div class="title">{{ isArabic ? 2 + $t('reward') : $t('reward') + 2  }}</div>
                  <div class="amount">{{ 7 }}</div>
                  <div class="name">{{ $t('vip') }}</div>
                  <img class="gift" src="./assets/images/icon_gift.png">
              </div>
          </div>
          <div class="reward-tip">{{ $t('after_completing') }}</div>
      </div>
      <div class="steps">
          <div class="step">
              <div class="left-img">
                  <img src="./assets/images/icon_step1.png">
              </div>
              <div v-html="$t('step_1')"></div>
          </div>
          <div class="step">
              <div class="left-img">
                  <img src="./assets/images/icon_step2.png">
              </div>
              <div v-html="$t('step_2')"></div>
          </div>
          <div class="step">
              <div class="left-img">
                  <img src="./assets/images/icon_step3.png">
              </div>
              <div v-html="$t('step_3')"></div>
          </div>
      </div>
      <div class="detail">
          <div>
              {{ $t('click_to') + (deviceType == 'ios' ? $t('app_store') : $t('google_play')) }}
              <div @click="jumpStore" class="content-store">
                  <div v-if="deviceType == 'ios'" class="btn">
                      <div class="left">
                          <img class="store-icon" src="./assets/images/icon_app_store.png" alt="">
                          <div class="text">
                              <div class="top">{{ $t('go_to') }}</div>
                              <div class="bottom">{{ $t('app_store') }}</div>
                          </div>
                      </div>
                      <img class="arrow-icon" src="@/assets/images/icon_arrow_right_grey.png" alt=""/>
                  </div>
                  <div v-else class="btn">
                      <div class="left">
                          <img class="store-icon" src="./assets/images/icon_google_play.png" alt="">
                          <div class="text">
                              <div class="top">{{ $t('go_to') }}</div>
                              <div class="bottom">{{ $t('google_play') }}</div>
                          </div>
                      </div>
                      <img class="arrow-icon" src="@/assets/images/icon_arrow_right_grey.png" alt=""/>
                  </div>
              </div>
          </div>
          <div>
              {{ $t('upload') }}
              <div class="content-example">
                  <img class="example" src="./assets/images/example_image.png">
                  {{ $t('example') }}
              </div>
          </div>
      </div>
      <div class="uploader-container">
          <Uploader 
              v-model="previewImage" 
              max-count="1"
              accept="image/*"
              image-fit="cover"
              :after-read="uploadImage"
              @delete="deleteImage"
          >
              <div class="uploader-area">
                  <img src="./assets/images/icon_uploader.png" alt="">
                  {{ $t('upload_screenshot') }}
              </div>
          </Uploader>
      </div>
      <div class="white-space"></div>
      <div @click="handleClaim" class="claim-btn" :class="{'active': previewImage.length == 1}">
          {{ $t('claim') }}
      </div>
      <van-dialog
        v-model="dialogVisble"
        :show-confirm-button="false"
      >
        <div v-if="status == 1" class="dialog-container">
          <img src="./assets/images/verification_inprogress.png" alt="">
          <div class="dialog-title">{{ 'Image verification in progress...' }}</div>
          <div class="dialog-content">
            <div v-html="$t('verification_inprogress')"></div>
          </div>
        </div>
        <div v-else-if="status == 2" class="dialog-container">
          <img src="./assets/images/verification_success.png" alt="">
          <div class="dialog-title">{{ 'Verification successful!' }}</div>
          <div class="dialog-content">
            <div v-html="$t('verification_success')"></div>
          </div>
        </div>
        <div v-else-if="status == 3 && dialogVisble" class="dialog-container">
          <img src="./assets/images/verification_failed.png" alt="">
          <div class="dialog-title">{{ 'Verification failed' }}</div>
          <div class="dialog-content">
            <div v-html="$t('verification_failed')"></div>
          </div>
          <div class="dialog-btn" @click="dialogVisble = false">{{ $t('reupload') }}</div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import UploadFile from "@/utils/upload.js"
import { Uploader } from "vant";
import Axios from "axios";

export default {
  components: { Uploader },
  data() {
    return {
        userId: null,
        avatar: null,
        nickName: null,
        dialogVisble: false,
        status: 0,
        previewImage: [],
        imageUrl: null,
        isExpired: false,
        deviceType: null,
        appName: null,
        tempRes: null
    };
  },
  computed: {
    isArabic() {
      // 根据实际情况判断是否应该使用阿拉伯语环境
      return this.$i18n.locale === "ar"
    },
    logoUrl() {
      if(this.appName) {
        return require(`@/assets/images/logo_${this.appName.toLowerCase()}.png`)
      }
      return null
    }
  },
  watch: {
    status: {
      handler(val) {
        this.dialogVisble = val == 0 ? false : true
      },
      immediate: true
    }
  },
  mounted() {
    const path = window.location.href.split('/').pop()
    this.userId = path.split('?')[0]
    this.getStatus()
    const userAgent = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(userAgent)) {
        // iOS设备            
        this.deviceType = 'ios'
    } else {
        // Android设备
        this.deviceType = 'andriod'
    }
  },
  methods: {
    jumpStore() {
      if (this.deviceType == 'ios') {
          this.jumpIOS();
      } else {
          this.jumpAndroid(this.user_id);
      }
    },
    jumpIOS() {
      let url = "https://apps.apple.com/app/id1573193510";
      switch (this.appName) {
        case "WeLive": {
          url = "https://apps.apple.com/app/id1590508975";
          break;
        }
        case "Mako": {
          url = "https://apps.apple.com/app/6444004401";
          break;
        }
        case "TenderU": {
          url = "https://apps.apple.com/app/6448168908";
          break;
        }
        case "Ayar": {
          url = "https://apps.apple.com/app/6444036077";
          break;
        }
        case "Bling": {
          url = "https://apps.apple.com/app/1668708050";
          break;
        }
        case "Meego": {
          url = "https://apps.apple.com/app/6475289236";
          break;
        }
        case "Ti.Live": {
          url = "https://apps.apple.com/app/6474960633";
          break;
        }
        case "Dico": {
          url = "https://apps.apple.com/app/6467689175";
          break;
        }
        case "Chato": {
          url = "https://apps.apple.com/app/6471557076";
          break;
        }
        case "ELive": {
          url =
            "https://play.google.com/store/apps/details?id=com.elive.joy.android";
          break;
        }
        case "CATA": {
          url =
            "https://apps.apple.com/us/app/cata-live-chat-online-call/id6744884776";
          break;
        }
        case "DADA": {
          url =
            "https://apps.apple.com/us/app/cata-live-chat-online-call/6747492193";
          break;
        }
        case "GELA": {
          url =
            "https://apps.apple.com/us/app/cata-live-chat-online-call/6747060536";
          break;
        }
        case "Yah Live": {
          url = 
            ""
          break;
        }
      }
      window.location.href = url;
    },
    jumpAndroid() {
      let url = "https://play.google.com/store/apps/details?id=com.tigo.flower";

      switch (this.appName) {
        case "WeLive": {
          url =
            "https://play.google.com/store/apps/details?id=com.video.welive";
          break;
        }
        case "TenderU": {
          url =
            "https://play.google.com/store/apps/details?id=com.client.tenderu.android";
          break;
        }
        case "Mako": {
          url =
            "https://play.google.com/store/apps/details?id=com.matchu.machat";
          break;
        }
        case "Ayar": {
          url =
            "https://play.google.com/store/apps/details?id=com.star.ayar.android";
          break;
        }
        case "Bling": {
          url =
            "https://play.google.com/store/apps/details?id=com.live.bling.android";
          break;
        }
        case "Meego": {
          url =
            "https://play.google.com/store/apps/details?id=com.app.meego.android";
          break;
        }
        case "Ti.Live": {
          url =
            "https://play.google.com/store/apps/details?id=com.ti.live.stream";
          break;
        }
        case "Dico": {
          url =
            "https://play.google.com/store/apps/details?id=org.dico.dream.android";
          break;
        }
        case "Chato": {
          url = "https://play.google.com/store/apps/details?id=com.chato.amigo";
          break;
        }
        case "ELive": {
          url =
            "https://play.google.com/store/apps/details?id=com.elive.joy.android";
          break;
        }
        case "Haii": {
            url =
              "https://play.google.com/store/apps/details?id=style.haii.www.android";
            break;
        }
        case "Cata": {
          url =
            "https://play.google.com/store/apps/details?id=net.cata.ai.android";
          break;
        }
        case "Dada": {
          url =
            "https://play.google.com/store/apps/details?id=fans.dada.app.android";
          break;
        }
        case "Gela": {
          url =
            "https://play.google.com/store/apps/details?id=live.gela.hap.android";
          break;
        }
        case "Poca": {
          url =
            "https://play.google.com/store/apps/details?id=connect.poca.android";
          break;
        }

        case "Fuga": {
          url =
            "https://play.google.com/store/apps/details?id=style.meet.fuga.android";
          break;
        }
        case "Pinka": {
          url =
            "https://play.google.com/store/apps/details?id=stream.pinka.android";
          break;
        }
        case "Toki": {
          url = 
            "https://play.google.com/store/apps/details?id=banter.toki.android"
          break;
        }
        case "Yah Live": {
          url = 
            "https://play.google.com/store/apps/details?id=com.gijoy.yah.live"
        }
      }
      window.location.href = url;
    },
    uploadImage(fileObj) {
        UploadFile(fileObj.file, "img").then((resp) => {
            this.imageUrl = resp
        })
    },
    deleteImage() {
        this.imageUrl = null
    },
    getStatus() {
      Axios.get('https://a.1f5fb85bd9c3.com/vchat/app/comment/getCommentStatus', {
        params: { 
          id: this.userId
        }
      }).then((resp) => {
        const res = resp.data
        if(res.status == 200) {
          this.nickName = res.data.nickName
          this.avatar = res.data.avatar
          this.status = res.data.status
          this.appName = res.data.appName
          this.$i18n.locale = res.data.language
        } else {
          this.isExpired = true
        }
        this.tempRes = res
      })
    },
    handleClaim() {
      if(!this.imageUrl) {
          return
      }
      Axios.post('https://a.1f5fb85bd9c3.com/vchat/app/comment/submitComment', { 
        id: this.userId,
        screenshot: this.imageUrl
      }).then((resp) => {
        const res = resp.data
        if(res.status == 200) {
          this.getStatus()
        }else {
          this.isExpired = true
        }
        this.tempRes = res
      })
    },
  }
};
</script>
<style lang="stylus">
* {
  margin: 0;
  padding: 0;

  &::-webkit-scrollbar {
    width: 0 !important;
  }
}
#app {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
.expired {
    width 100%;
    height: 40vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    div {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin: 10px 0;
    }
}
.submit-container {
  background: #F6F7FB;
  font-family: Poppins;
  height: 100vh;
  padding: 0 16px;
  overflow: scroll;
  .icon {
      width: 60px;
      height: 60px;
      border-radius: 15px;
  }
  .top-bar {
      margin-top: 16px;
      display: flex;
      justify-content: space-between;
      .left {
          .title {
              font-size: 18px;
              font-weight: 800;
              color: #000000;
              white-space: nowrap;      /* 不换行 */
              overflow: hidden;         /* 隐藏溢出内容 */
              text-overflow: ellipsis;  /* 显示省略号 */
              width: 290px;
          }
          .tip {
              font-size: 12px;
              color: rgba(0, 0, 0, 0.6);
          }
      }
      .avatar-box {
        width: 54px;
        height: 54px;
        border-radius: 50%;
        position: relative;
        overflow: hidden;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          border: none;
          object-fit: cover;
        }   
      }
  }
  .reward-list {
      width: 343px;
      height: 215px;
      border-radius: 16px;
      margin-top: 16px;
      padding: 14px 20px;
      background: linear-gradient(180deg, #FFF2C0 0%, #FFF6E2 100%);
      display: flex;
      flex-direction: column;
      align-items: center;
      .reward-title {
          font-size: 16px;
          font-weight: 800;
      }
      .rewards {
          width: 100%;
          margin-top: 12px;
          display: flex;
          justify-content: space-between;
          position: relative;
          .reward {
              width: 144px;
              height: 118px;
              border-radius: 16px;
              background: linear-gradient(180deg, #FF3900 0%, #FF832B 97%);
              display: flex;
              flex-direction: column;
              align-items: center;
              position: relative;
              .title {
                  color: #FF5A21;
                  line-height: 4px;
                  font-weight: 600;
                  padding: 10px 25px;
                  background: url('https://web.tigodating.com/images/good_review/background_trapezoid.png') no-repeat center center / contain;
              }
              .amount {
                  font-size: 30px;
                  font-weight: bold;
                  color: #fff;
                  margin-top: 20px;
              }
              .name {
                  font-size: 16px;
                  font-weight: 600;
                  color: #fff;
                  margin-top: 10px;
              }
              .gift {
                  width: 100px;
                  height: auto;
                  position: absolute;
                  top: 30%;
                  right: -15%;
              }
          }
          .plus {
              position: absolute;
              left: 44.5%;
              top: 35%;
              z-index: 2;
              padding: 9px;
              background: #FFF4D5;
              border-radius: 50%;
              img {
                  width: 16px;
                  height: 16px;
              }
          }
      }
      .reward-tip {
          font-size: 10px;
          line-height: 134%;
          color: rgba(0, 0, 0, 0.4);
          margin-top: 6px;
      }
  }
  .steps {
      width: 100%;
      background: #fff;
      border-radius: 16px;
      margin-top: 16px;
      padding: 24px 16px;
      display: flex;
      flex-direction: column;
      .step {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left-img {
              padding: 9px;
              border-radius: 10px;
              background: #EDF9FE;
              margin-right: 16px;
              img {
                  width: 24px;
                  height: 24px;
              }
          }
          .content {
              display: flex;
              justify-content: center;
              align-items: center;
              .btn {
                  width: 180px;
                  height: 54px;
                  border-radius: 16px;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  padding: 12px 16px;
                  background: #FFFFFF;
                  box-sizing: border-box;
                  border: 1px solid rgba(0, 0, 0, 0.12);
              }
          }
      }
      .step:nth-child(2) {
          margin: 24px 0;
      }
  }
  .detail {
      font-size: 14px;
      font-weight: 600;
      color: #000000;
      margin-top: 16px;
      .content-store {
          margin: 16px 0;
          display: flex;
          justify-content: center;
          .btn {
              width: 180px;
              height: 54px;
              border-radius: 16px;
              padding: 12px 16px;
              background: #FFFFFF;
              border: 1px solid rgba(0, 0, 0, 0.12);
              display: flex;
              align-items: center;
              .left {
                  flex: 1;
                  display: flex;
                  align-items: center;
                  .store-icon {
                      width: 32px;
                      height: 32px;
                  }
                  .text {
                      margin-left: 8px;
                      .top {
                          height: 16px;
                          font-size: 10px;
                          color: #666666;
                          
                      }
                      .bottom {
                          height: 20px;
                          color: #333333;
                      }
                  }
              }
              .arrow-icon {
                  width: 12px;
                  height: 12px;
              }
          }
      }
      .content-example {
          width: 100%;
          font-size: 10px;
          color: rgba(0, 0, 0, 0.4);
          margin: 16px 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .example {
              width: 140px;
              height: 80px;
              background: #fff;
              padding: 6px 8px;
          }
      }
  }
  .uploader-container {
      .uploader-area {
          color: #BCBCBC;
          font-size: 10px;
          font-weight: 500;
          width: 343px;
          height: 141px;
          border-radius: 16px;
          padding: 37px 117.5px;
          background: #ECEDF1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
              width: 25px;
              height: 25px;
          }
      }
      .van-uploader {
          width: 343px;
          height: 141px;
          border-radius: 16px;
          background: #ECEDF1;
      }
      .van-uploader__wrapper {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
      }
      .van-uploader__preview {
          height: 100%;
      }
      .van-image {
          height: 100%;
          object-fit: cover;
          img {
              width: 100%;
              height: 100%;
          }
      }
  }
  .white-space {
      width: 100%;
      height: 80px;
  }
  .claim-btn {
      color: #FFFFFF;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      background: #B3B3B3;
      width: 343px;
      height: 56px;
      padding: 16px 55px;
      border-radius: 16px;
      position: fixed;
      bottom: 16px;
      &.active {
          background: #000000;
      }
  }
  .dialog-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    .dialog-title {
      font-size: 18px;
      font-weight: 800;
      color: #000000;
      text-align: center;
      margin: 6px;
    }
    .dialog-content {
      font-size: 12px;
      font-weight: 400;
      margin: 16px 6px;
    }
    .dialog-btn {
      color: #FFFFFF;
      width: 100%;
      height: 45px;
      line-height: 45px;
      background: #000000;
      text-align: center;
      border-radius: 12px;
    }
    img {
      width: 110px;
      height: 110px;
    }
  }
}
</style>